<template>
  <div class="topBar">
    <div :class="($route.name ? 'top-fixed top' : 'top')+(menuOpen ? ' open' : '')">
      <div class="menu-icon" @click="changeMenu">
        <hamburger :open="menuOpen"></hamburger>
      </div>
      <div class="title font-module-title en" v-if="$route.name">{{ $route.name }}</div>
      <div class="logo" @click="goMain">
      <img v-if="$store.state.color == 'white'" src="@/assets/img/logo-white.png" />
      <img v-if="$store.state.color == 'black'" src="@/assets/img/logo-black.png" />
      </div>
    </div>
    <div class="lock" v-if="menuOpen" @click="changeMenu"></div>
    <Transition name="fade">
      <div class="drawer" v-if="menuOpen">
        <div class="menu-logo prison"><img src="@/assets/img/logo-black.png" /></div>
        <div class="menu-item">
          <span class="font-menu en hove-link" @click="goPage('home')">Home</span>
        </div>
        <div class="menu-item">
          <span class="font-menu en hove-link" @click="goPage('galleryArtist')">Artist</span>
          <!-- <span :class="selectPage == 'gallery' ? 'under-link font-menu en hove-link' : 'font-menu en hove-link'" @click="goPage('galleryArtist')">Artist</span>
          <Transition name="child">
            <div class="child" v-if="selectPage == 'gallery'">
              <div class="child-item">
                <span class="font-menu-sub en hove-link" @click="goPage('galleryArtist')"
                  >Artist</span
                >
              </div>
              <div class="child-item">
                <span class="font-menu-sub en hove-link" @click="goPage('galleryMaterial')"
                  >Material</span
                >
              </div>
            </div>
          </Transition> -->
        </div>
        <div class="menu-item">
          <span :class="selectPage == 'exhibition' ? 'under-link font-menu en hove-link' : 'font-menu en hove-link'" @click="goPage('exhibition')"
            >Exhibition</span
          >
          <Transition name="child">
            <div class="child" v-if="selectPage == 'exhibition'">
              <div class="child-item">
                <span class="font-menu-sub en hove-link" @click="goPage('exhibitionImage')"
                  >Image</span
                >
              </div>
              <div class="child-item">
                <span class="font-menu-sub en hove-link" @click="goPage('exhibitionList')"
                  >List</span
                >
              </div>
            </div>
          </Transition>
        </div>
        <div class="menu-item">
          <span class="font-menu en hove-link" @click="goPage('about')">About</span>
        </div>
      </div>
    </Transition>
  </div>

</template>

<script >
import hamburger from "@/components/hamburger"
export default {
    name:"topBarComponent",
    components: {
      hamburger
    },
    data() {
        return {
          menuOpen:false,
          selectPage:null,
        }
    },
    methods:{
        goMain(){
          this.$router.push("/");
          this.selectPage = null
          this.menuOpen=false;
        },
        changeMenu(){
          this.menuOpen = !this.menuOpen;
          if(this.menuOpen){
            document.body.style.overflow="hidden";
          }else{
            document.body.style.overflow="auto";
          }
        },
        goPage(name){
          switch (name) {
            case 'gallery':
            case 'exhibition':
              this.selectPage = name == this.selectPage ? null : name
              return null
            case 'home':
              this.$router.push('/')
              break
            case 'galleryArtist':
              this.$router.push('/artist')
              break
            case 'galleryMaterial':
              this.$router.push('/material')
              break
            case 'exhibitionImage':
              this.$router.push('/exhibition/image')
              break
            case 'exhibitionList':
              this.$router.push('/exhibition/list')
              break
            case 'about':
              this.$router.push('/about')
              break
            default:
              break
          }
          this.selectPage = null
          this.changeMenu();
        }
    }
};
</script>
<style lang="less" scoped>
.topBar{
  position: absolute;
  width: 100%;
}
.top{
  position: absolute;
  z-index: 90;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 120px;
  padding: 0px 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .menu-icon{
    width: 18px;
    height: 15px;
    cursor: pointer;
  }
  .title{
    display: none;
  }
  .logo{
    width: 26px;
    height: 40px;
    cursor: pointer;
  }
}

.fade-enter-from{
  opacity: 0;
}
.fade-enter-active{
  opacity: 0.5;
}
.fade-enter-to {
    opacity: 1;
}
.fade-leave-to {
    opacity: 0;
}


.child-enter-from{
  opacity: 0;
}
.child-enter-active{
  opacity: 0.5;
}
.child-enter-to {
    opacity: 1;
}
.child-leave-to {
    opacity: 0;
}

.drawer {
  transition: all 0.3s ease;
  position: fixed;
  z-index: 80;
  left: 0rem;
  top: 0rem;
  height: 100vh;
  width: 280px;
  background-color: #fff;
  padding-left: 50px;
  padding-top: 150px;
  .menu-logo{
    display: none;
  }
  .menu-item {
    margin-bottom: 30px;
    span {
      cursor: pointer;
    }
    .child {
      transition: all 0.3s ease;
      .child-item {
        span {
          color: rgba(0, 0, 0, 0.5);
        }
        margin-top: 13px;
      }
    }
  }
}

.lock {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 70;
}

@media screen and (max-width: 1023px) {
  .top-fixed{
    border-bottom: 0.5px solid #4d4d4d;
    position: fixed;
    background-color: #f3f3f3;
    &.open{
      border-bottom: unset;
      background-color: unset;
      .title{
        display: none;
      }
    }
  }
  .open{
    .logo{
      opacity: 0;
    }
  }
  .top{
    height: 65px;
    padding: 0 20px;
    .title{
      display: block;
    }
    .logo{
      width: 21px;
      height: 32px;
    }
  }
  .drawer {
    padding: 0px;
    display: flex;
    width: 100% !important;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .menu-logo{
      display: block;
      position: fixed;
      right: 20px;
      top: 0px;
      width: 21px;
      height: 64px;
    }
    .menu-item {
      margin-bottom: 30px;
      span {
        cursor: pointer;
        text-align: center;
        line-height: 16px;
      }
      .child {
        padding-top: 9px;
        .child-item {
          span {
            text-align: center;
            width: 100%;
            display: block;
            line-height: 16px;
          }
          margin-top: 17px;
        }
      }
    }
  }
  .nav-header {
    height: 66px;
    padding: 18px 20px;
    .nav-right {
      img {
        width: 21px;
        height: 32px;
      }
    }
  }
  .lock {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topBar/index.vue